export default __webpack_public_path__ + "static/media/icon-check.109ef850.svg";